import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

// action types
export const UPDATE_TABLE_STRUCTURE = "getCATEGORIESTableStructure";
export const UPDATE_TABLE_DATA = "getCATEGORIESTableData";
export const UPDATE_CREATE_DATA = "getCATEGORIESCreateData";
export const EXPORT_TABLE_DATA = "exportCATEGORIESTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setCATEGORIESTableStructure";
export const SET_TABLE_DATA = "setCATEGORIESTableData";
export const SET_CREATE_DATA = "setCATEGORIESCreateData";
export const SET_TABLE_FILTER = "setCATEGORIESTableFilter";
export const SET_TABLE_PAGE = "setCATEGORIESTablePage";
export const SET_TABLE_PERPAGE = "setCATEGORIESTablePerPage";
export const SET_TABLE_SORTBY = "setCATEGORIESTableSortBy";
export const SET_TABLE_SORTORDER = "setCATEGORIESTableSortOrder";
export const SET_EXPORT_LINK = "setCATEGORIESExportLink";

const state = {
  export_link: null,
  table_structure: {},
  table_data: {},
  create_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
};

const getters = {
  getCATEGORIESTableState(state) {
    return state.table_state;
  },

  getCATEGORIESTableHeaders(state) {
    return state.table_structure.columns;
  },

  getCATEGORIESTableFilters(state) {
    return state.table_structure.filters;
  },

  getCATEGORIESTablePermissions(state) {
    return state.table_structure.permissions;
  },

  getCATEGORIESTableData(state) {
    return state.table_data.data;
  },

  getCATEGORIESTableProperties(state) {
    return state.table_structure.properties;
  },

  getCATEGORIESCreateData(state) {
    return state.create_data;
  },
  getCATEGORIESExportUrl(state) {
    return state.export_link;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    return new Promise((resolve) => {
      ApiService.post("/stores/portal/categories")
        .then(({ data }) => {
          context.commit(SET_TABLE_STRUCTURE, data);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_CREATE_DATA](context) {
    return new Promise((resolve) => {
      ApiService.post("/stores/portal/categories/create")
        .then(({ data }) => {
          context.commit(SET_CREATE_DATA, data);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](
    context,
    parent_id,
    payload = this.getters.getCATEGORIESTableState
  ) {
    context.commit(SET_PAGE_LOADING, true);
    let url = "/stores/portal/categories/datatable";
    if (parent_id > -1) url = url + "?category_id=" + parent_id;
    return new Promise((resolve) => {
      ApiService.post(url, payload)
        .then(({ data }) => {
          context.commit(SET_TABLE_DATA, data);
          resolve(data);

          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/stores/portal/categories/export", payload)
        .then(({ data }) => {
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },
  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_SORTORDER](state, sortOrder) {
    state.table_state.sortOrder = sortOrder;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_CREATE_DATA](state, data) {
    state.create_data = data;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
